export interface PlayerFormParent {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  xHandle: string;
  slackUsername: string;
}

export interface PlayerFormState {
  // Personal info
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  xHandle: string;
  slackUsername: string;
  instagramUrl: string;

  // Links
  videoLink: string;
  scoutingProfileLink: string;

  // Player details
  position: string;
  bats: string;
  throws: string;
  heightFeet: string;
  heightInches: string;
  weight: string;

  // High school
  school: string;
  gradYear: string;
  city: string;
  state: string;
  gpa: string;
  intendedMajor: string;
  coachName: string;
  coachPhone: string;
  schoolTwitter: string;

  // Travel ball
  travelTeam: string;
  travelTeamCoachName: string;
  travelTeamCoachPhone: string;
  travelTeamTwitter: string;

  // Recruiting
  preferredLocations: string[];
  endGoal: string;
  recruitmentStage: string;
  projectedDivisions: string[];

  // Parents
  parents: PlayerFormParent[];
  parentDraft: PlayerFormParent | null;

  // Notes
  notes: string;
}

export type PlayerFormErrors = Partial<Record<string, string>>;

/**
 * Human-readable names for the fields `validate()` can reject.
 *
 * The validator's own messages are deliberately terse ("Required") because they
 * render directly under a labelled field. An error summary has no such context,
 * so it pairs the message with the field name from this map.
 */
export const PLAYER_FORM_FIELD_LABELS: Record<string, string> = {
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  phone: "Phone",
  position: "Main Position",
  bats: "Bats",
  throws: "Throws",
  heightFeet: "Height (ft)",
  weight: "Weight (lbs)",
  school: "School",
  city: "City",
  state: "State",
  gradYear: "Grad Year",
  preferredLocations: "Preferred Locations",
};

export interface PlayerFormSetters {
  set: <K extends keyof PlayerFormState>(field: K, value: PlayerFormState[K]) => void;
  setParents: (parents: PlayerFormParent[]) => void;
  setParentDraft: (draft: PlayerFormParent | null) => void;
  updateParentDraft: (field: keyof PlayerFormParent, value: string) => void;
  togglePreferredLocation: (state: string) => void;
  clearError: (field: string) => void;
}
